import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

export const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Public API calls
export const fetchPublicListings = async () => {
  const response = await api.get('/listings/public');
  return response.data;
};

export const fetchPublicNews = async () => {
  const response = await api.get('/news/public');
  return response.data;
};

export const submitContact = async (data) => {
  const response = await api.post('/contact', data);
  return response.data;
};

// Admin API calls
export const fetchListings = async () => {
  const response = await api.get('/listings', { headers: getAuthHeader() });
  return response.data;
};

export const createListing = async (data) => {
  const response = await api.post('/listings', data, { headers: getAuthHeader() });
  return response.data;
};

export const updateListing = async (id, data) => {
  const response = await api.put(`/listings/${id}`, data, { headers: getAuthHeader() });
  return response.data;
};

export const deleteListing = async (id) => {
  const response = await api.delete(`/listings/${id}`, { headers: getAuthHeader() });
  return response.data;
};

export const fetchNews = async () => {
  const response = await api.get('/news', { headers: getAuthHeader() });
  return response.data;
};

export const createNews = async (data) => {
  const response = await api.post('/news', data, { headers: getAuthHeader() });
  return response.data;
};

export const updateNews = async (id, data) => {
  const response = await api.put(`/news/${id}`, data, { headers: getAuthHeader() });
  return response.data;
};

export const deleteNews = async (id) => {
  const response = await api.delete(`/news/${id}`, { headers: getAuthHeader() });
  return response.data;
};

export const fetchContacts = async () => {
  const response = await api.get('/contacts', { headers: getAuthHeader() });
  return response.data;
};

export const deleteContact = async (id) => {
  const response = await api.delete(`/contacts/${id}`, { headers: getAuthHeader() });
  return response.data;
};

export const markContactRead = async (id) => {
  const response = await api.put(`/contacts/${id}/read`, {}, { headers: getAuthHeader() });
  return response.data;
};

export const markContactUnread = async (id) => {
  const response = await api.put(`/contacts/${id}/unread`, {}, { headers: getAuthHeader() });
  return response.data;
};

// Stats
export const fetchStats = async () => {
  const response = await api.get('/stats', { headers: getAuthHeader() });
  return response.data;
};